"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = void 0;
/**
 * Debounces calls to occur after elasped miliseconds
 *
 * @name debounce
 * @param {Function} callback Method being called
 * @param {Number} delay Amount of time to defer calling method, after last invocation
 * @returns {Variable} Result of the callback method
 */
const debounce = (callback, delay) => {
  let timer;
  return function () {
    for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
      rest[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      callback(rest);
    }, delay);
  };
};
exports.debounce = debounce;